import { Component, Input } from '@angular/core';
import { to64decode } from 'src/app/helpers/base64';
import { getLanguageCookie } from 'src/assets/language';
import { MatTableDataSource } from '@angular/material/table';
import { v4 } from "uuid";
import { addAlert, apiOfflineAsync } from "../../../../layouts/pages/pages.component";
import { ExtendedAttributeService } from 'src/app/services/extended_attribute/extended-attribute.service';
import { sortArrayOfObjects } from 'src/app/helpers/sortArrayOfObjects';
@Component({
  selector: 'app-extended-attributes',
  templateUrl: './extended-attributes.component.html',
  styleUrls: ['./extended-attributes.component.scss']
})
export class ExtendedAttributesComponent {
  @Input() parameters: any = {}
  @Input() dimensions: any = {}

  selectedFlag: any = {
    lang: 'en',
    file: 'us.svg'
  };

  dataSource!: MatTableDataSource<any>;
  displayedColumns: string[] = ['name','content', 'inclusion_date', 'last_change_date', 'action'];
  currentPage = 1;
  currentPageReq = 1;
  itemsPerPage = 10;

  currentAttribute: any = {}

  searchAttribute: string = ''
  attributeArray: any = []

  isShowCreate: boolean = false; 

  newAttributeJson: any = {
    uuid: '',
    name: '',
    type: '',
    values: '',
  }

  attributeTypeArray: any = []
  searchType: string = ''
  selectedType: any
  searchContent: string = ''
  booleanFieldArray: any = [true, false]

  selectedBoolean: any = {}

  constructor(
    private extendedAttribute: ExtendedAttributeService
  ) {
    this.dataSource = new MatTableDataSource();
  }

  async ngOnInit(){
    this.dataSource.data = this.parameters.item.extendedAttributes || []
    this.attributeTypeArray = this.parameters.optionsArray.attributeTypeEnum
    await this.getCorporationExtendedAttribute()
  }

  async getCorporationExtendedAttribute() {
    try {
      const response: any = await this.extendedAttribute.getCorporationExtendedAttribute();
      if(response.data){
        this.attributeArray = []
        this.attributeArray.push({uuid: '-1', name: 'New +'})
        this.attributeArray.push(...sortArrayOfObjects(response.data))
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  getNames(name: any){
    return name[to64decode(localStorage.getItem('language')).lang]
  }

  getLanguages(file: string){
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  isData(){
    return this.dataSource.data.length > 0
  }

  getDisplayedRows(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.dataSource.data.slice(startIndex, endIndex);
  }

  getColumns(){
    return this.displayedColumns.slice(1)
  }

  getItemsPerPage(){
    return this.itemsPerPage
  }

  getCurrentPages(): number{
    return this.currentPage
  }

  choseItemsPage(number: number){
    this.itemsPerPage = number;
    this.getDisplayedRows()
  }

  onPageChange(newPage: number, text: string): void {
    this.currentPage = newPage;
  }

  getTotalPages(): number {
    return Math.ceil(this.dataSource.data.length / this.itemsPerPage);
  }

  async checkValue() {
    let total = this.getTotalPages()
    if (this.currentPage > total) this.currentPage = total;
  }

  async newAttribute(){
    if(!this.parameters.isEdit){
      return
    }
    this.currentAttribute = {
      uuid: v4(),
      name: '',
      type: '',
      content: '',
      created_date: '',
      updated_date: '',
    };
    this.dataSource.data.push(this.currentAttribute)
  }

  choseItemSelect(type: string, value: any, element: any){
    switch (type) {
      case 'attribute':
        if(value.uuid == '-1'){
          this.isShowCreate = true
        }else{
          element.name = value.name
          element.type = value.type
          element.content = ''
        }
        break;
      case 'content':
        element.content = value
        break;
      case 'boolean':
        element.content = value
        this.selectedBoolean = value
        break;
      case 'attributeType':
        this.selectedType = value
        this.newAttributeJson.type = value.slug
        break;
      default:
        break;
    }
  }

  async deleteAttribute(uuid: string) {
    if(!this.parameters.isEdit){
      return
    }

    this.dataSource.data = this.dataSource.data.filter(item => item.uuid !== uuid);
    this.parameters.item.extendedAttributes = this.dataSource.data
  }

  setValidsInputs(){
    let inputs: any = []

    if (!this.newAttributeJson.name || this.newAttributeJson.name == '') {
      inputs.push(this.getLanguages('businessSolution/modal/extendedAttributes/name'))
    }

    if (!this.newAttributeJson.type || this.newAttributeJson.type == '') {
      inputs.push(this.getLanguages('businessSolution/modal/extendedAttributes/type'))
    }

    if (this.newAttributeJson.type == 'restricted-text' && (!this.newAttributeJson.values || this.newAttributeJson.values == '')) {
      inputs.push(this.getLanguages('businessSolution/modal/extendedAttributes/possibleValues'))
    }
    
    if (inputs.length > 0) {
      addAlert('orange', `${this.getLanguages('mandatoryField')}${inputs.join(`, `)}`)
      return false
    }
    return true
  }


  async setAttribute(){
    if (!this.setValidsInputs()) {
      return;
    }
    let flag = false;

    this.attributeArray.forEach((item: any) => {
      if(item.name == this.newAttributeJson.name){
        addAlert('orange', this.getLanguages('businessSolution/modal/extendedAttributes/extended_attribute_already_registered'))
        flag = true
        return
      }
    });

    if(flag){
      return
    }

    if(this.newAttributeJson.name == 'New +'){
      addAlert('danger', this.getLanguages('auth/alert/nameReservedWord'))
      return
    }

    if(this.newAttributeJson.type != 'restricted-text'){
      this.newAttributeJson.values = ''
    }

    if(typeof(this.newAttributeJson.values) === 'string'){
      this.newAttributeJson.values = this.newAttributeJson.values
      .split(';')
      .map((value: string) => value.trim())
      .filter((value: string) => value !== '');
    }
    
    this.newAttributeJson.uuid = v4()
    
    try {
      const response:any = await this.extendedAttribute.setCorporationExtendedAttribute(this.newAttributeJson);
      if (response && [201, 202].includes(response.status) ) {
        addAlert('success', response.message)
        this.newAttributeJson = {
          uuid: '',
          name: '',
          type: '',
          values: '',
        }
        delete this.selectedType
        this.isShowCreate = false
        await this.getCorporationExtendedAttribute();
      } else {
        addAlert('danger', response.message)
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  autoResize(event: Event, row?: any): void {
    const textarea = event.target as HTMLTextAreaElement;
    const tr = textarea.closest('tr');
    
    if (!tr) {
      return;
    }

    const textareas = tr.querySelectorAll('textarea');
    let maxHeight = 0;

    textareas.forEach((ta: HTMLTextAreaElement) => {
      ta.style.height = 'auto'; 
      const taHeight = ta.scrollHeight;
      if (taHeight > maxHeight) {
        maxHeight = taHeight;
      }
    });

    textareas.forEach((ta: HTMLTextAreaElement) => {
      ta.style.height = `${maxHeight}px`;
    });
  }
  
  getArrayContent(name: string): any[]{
    let array: any = []
    this.attributeArray.forEach((item: any) => {
      if(item.name == name){
        array = item.values
      }
    });
    return array
  }

  formatDate(date: Date): string {
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const seconds = ('0' + date.getSeconds()).slice(-2);
  
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

  validateInput(event: KeyboardEvent, row: any): boolean {
    const charCode = event.charCode;
    const char = String.fromCharCode(charCode);
    
    switch (row.type) {
      case 'data':
        // Permite apenas números e barra
        if (!/[\d/]/.test(char)) {
          event.preventDefault();
          return false;
        }
        
        // Se for barra, verifica se já não existe uma barra no campo
        if (char === '/') {
          const textarea = event.target as HTMLTextAreaElement;
          if (textarea.value.includes('/')) {
            event.preventDefault();
            return false;
          }
        }
        break;
        
      case 'decimal':
        // Permite apenas números, ponto e vírgula
        if (!/[\d.,]/.test(char)) {
          event.preventDefault();
          return false;
        }
        
        // Se for ponto ou vírgula, verifica se já não existe um no campo
        if (char === '.' || char === ',') {
          const textarea = event.target as HTMLTextAreaElement;
          if (textarea.value.includes('.') || textarea.value.includes(',')) {
            event.preventDefault();
            return false;
          }
        }
        break;
        
      case 'integer':
        // Permite apenas números
        if (!/\d/.test(char)) {
          event.preventDefault();
          return false;
        }
        break;

      case 'real':
        // Permite apenas números
        if (!/\d/.test(char)) {
          event.preventDefault();
          return false;
        }
        break;
    }
    
    return true;
  }

  formatContent(event: Event, row: any): void {
    const textarea = event.target as HTMLTextAreaElement;
    let value = textarea.value;

    switch (row.type) {
      case 'data':
        // Remove todos os caracteres exceto números e barras
        value = value.replace(/[^\d/]/g, '');
        // Se o valor estiver vazio, retorna vazio
        if (!value) {
          row.content = '';
          return;
        }
        value = this.formatDateInput(value);
        // Limita o tamanho total da string para DD/MM/AAAA (10 caracteres)
        if (value.length > 10) {
          value = value.substring(0, 10);
        }
        break;
      case 'decimal':
        value = this.formatDecimalInput(value);
        break;
      case 'integer':
        value = this.formatIntegerInput(value);
        break;
      case 'boolean':
        value = this.formatBooleanInput(value);
        break;

      case 'real':
        value = this.formatRealInput(value);
        break;
      default:
        break;
    }

    row.content = value;
    this.autoResize(event, row);
  }

  formatRealInput(value: string): string {
    // Remove tudo que não é número
    value = value.replace(/\D/g, '');
  
    if (!value) return '';
  
    // Garante pelo menos dois dígitos para centavos
    while (value.length < 3) {
      value = '0' + value;
    }
  
    // Parte inteira e centavos
    const cents = value.slice(-2);
    let integer = value.slice(0, -2);
  
    // Adiciona separadores de milhar com '.'
    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
    return `R$ ${integer},${cents}`;
  }
  

  formatDateInput(value: string): string {
    // Remove todos os caracteres não numéricos
    let numbers = value.replace(/\D/g, '');
    
    // Limita a 8 dígitos (ddmmaaaa)
    numbers = numbers.substring(0, 8);
    
    // Apenas dia
    if (numbers.length >= 1 && numbers.length <= 2) {
      if (numbers === '00') return '01';
      return numbers;
    } else if (numbers.length >= 3 && numbers.length <= 4) {
      // Dia e mês
      let day = numbers.substring(0, 2);
      let month = numbers.substring(2);

      if (day === '00') day = '01';
      if (month === '00') month = '01';

      const monthInt = parseInt(month);
      let maxDay = 31;
      if ([4, 6, 9, 11].includes(monthInt)) {
        maxDay = 30;
      } else if (monthInt === 2) {
        maxDay = 29; // Só limita para 29, pois não há ano ainda
      }
      if (parseInt(day) > maxDay) day = String(maxDay).padStart(2, '0');
      if (parseInt(month) > 12) month = '12';

      return `${day}/${month}`;
    } else if (numbers.length >= 5) {
      // Dia, mês e ano
      let day = numbers.substring(0, 2);
      let month = numbers.substring(2, 4);
      let year = numbers.substring(4, 8); // <-- garantir que year está definido

      if (day === '00') day = '01';
      if (month === '00') month = '01';

      const monthInt = parseInt(month);
      let maxDay = 31;
      if ([4, 6, 9, 11].includes(monthInt)) {
        maxDay = 30;
      } else if (monthInt === 2) {
        // Verifica se é ano bissexto apenas se o ano tiver 4 dígitos
        if (year.length === 4) {
          const yearInt = parseInt(year);
          if ((yearInt % 4 === 0 && yearInt % 100 !== 0) || (yearInt % 400 === 0)) {
            maxDay = 29;
          } else {
            maxDay = 28;
          }
        } else {
          maxDay = 29; // Permite até 29 enquanto o ano não está completo
        }
      }
      if (parseInt(day) > maxDay) day = String(maxDay).padStart(2, '0');
      if (parseInt(month) > 12) month = '12';
      if (year === '0000') year = '0001';

      return `${day}/${month}/${year}`;
    }
    
    return numbers;
  }

  formatDecimalInput(value: string): string {
    // Substitui vírgula por ponto
    value = value.replace(',', '.');
    
    // Remove todos os caracteres exceto números e ponto
    value = value.replace(/[^\d.]/g, '');
    
    // Garante que só há um ponto decimal
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }
    
    // Limita a 2 casas decimais
    if (parts.length === 2) {
      parts[1] = parts[1].substring(0, 2);
      value = parts.join('.');
    }
    
    return value;
  }

  formatIntegerInput(value: string): string {
    // Remove todos os caracteres não numéricos
    return value.replace(/\D/g, '');
  }

  formatBooleanInput(value: string): string {
    // Converte para minúsculas e remove espaços
    value = value.toLowerCase().trim();
    
    // Mapeia valores comuns para true/false
    const trueValues = ['true', 'sim', 'yes', '1', 's'];
    const falseValues = ['false', 'não', 'nao', 'no', '0', 'n'];
    
    if (trueValues.includes(value)) return 'true';
    if (falseValues.includes(value)) return 'false';
    
    return value;
  }

  getPlaceholder(type: string): string {
    switch (type) {
      case 'data':
        return 'DD/MM/AAAA';
      case 'decimal':
        return '0.00';
      case 'integer':
        return '0';
      case 'boolean':
        return 'Sim/Não';
      case 'free-text':
        return '';
      case 'real':
        return 'R$ 0,00';
      default:
        return '';
    }
  }
}
